// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"58":"fb311513","722":"a3aa05d2"}[chunkId] + ".chunk.css";
};